const ProofBanner = () => (
    <section data-testid="proof-banner" className="border-b border-border bg-card">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-6 py-10 text-center md:flex-row md:px-10 md:text-left">
            <p className="font-serif text-xl italic text-muted-foreground md:text-2xl">
                Built on the actual playbook one senior leader used to land three interviews
                in 60 days.
            </p>
            <a href="#case-study" className="slate-link text-sm uppercase tracking-[0.25em] text-foreground">
                Read Maggie&apos;s story →
            </a>
        </div>
    </section>
);

export default ProofBanner;
